/**
 * Function that adds event listeners to all links with .scrollToSection class
 *
 * @returns {void}
 */
const listenToAnchorClicks = () => {
  $('.scrollToSection').on('click', function(event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop:$(this.hash).offset().top -50
    }, 1000);
  });
};

export {
  listenToAnchorClicks,
};
